var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCargando(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      margin: "auto",
      background: "#ffffff",
      display: "block"
    },
    width: 113,
    height: 28,
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        text {\r\n        text-anchor: middle; font-size: 14px; opacity: 0;\r\n        }\r\n    ")), /*#__PURE__*/React.createElement("g", {
    style: {
      transformOrigin: "56.5px 14px",
      transform: "scale(0.318182)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.5,14)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "-108.13px -2.5256px",
      animation: "1s linear -0.6s infinite normal forwards running fade-926a1358-fcdf-495b-96e6-661e57c75436"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.89-15.36L1.89-15.36Q1.89-19.84 3.92-23.43L3.92-23.43L3.92-23.43Q5.94-27.02 9.44-29.04L9.44-29.04L9.44-29.04Q12.94-31.06 17.20-31.06L17.20-31.06L17.20-31.06Q22.22-31.06 25.96-28.64L25.96-28.64L25.96-28.64Q29.70-26.22 31.42-21.78L31.42-21.78L26.62-21.78L26.62-21.78Q25.34-24.46 22.95-25.94L22.95-25.94L22.95-25.94Q20.55-27.41 17.20-27.41L17.20-27.41L17.20-27.41Q13.99-27.41 11.44-25.94L11.44-25.94L11.44-25.94Q8.89-24.46 7.44-21.71L7.44-21.71L7.44-21.71Q5.98-18.96 5.98-15.36L5.98-15.36L5.98-15.36Q5.98-11.75 7.44-9.02L7.44-9.02L7.44-9.02Q8.89-6.29 11.44-4.82L11.44-4.82L11.44-4.82Q13.99-3.34 17.20-3.34L17.20-3.34L17.20-3.34Q20.55-3.34 22.95-4.80L22.95-4.80L22.95-4.80Q25.34-6.25 26.62-8.93L26.62-8.93L31.42-8.93L31.42-8.93Q29.70-4.53 25.96-2.13L25.96-2.13L25.96-2.13Q22.22 0.26 17.20 0.26L17.20 0.26L17.20 0.26Q12.94 0.26 9.44-1.74L9.44-1.74L9.44-1.74Q5.94-3.74 3.92-7.30L3.92-7.30L3.92-7.30Q1.89-10.87 1.89-15.36L1.89-15.36",
    fill: "#5e6fa3",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-124.78497314453125,12.874397638494322)",
    style: {
      fill: "rgb(94, 111, 163)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "-76.695px 0.819397px",
      animation: "1s linear -0.54s infinite normal forwards running fade-926a1358-fcdf-495b-96e6-661e57c75436"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.86-12.14L35.86-12.14Q35.86-15.84 37.36-18.63L37.36-18.63L37.36-18.63Q38.85-21.43 41.47-22.97L41.47-22.97L41.47-22.97Q44.09-24.51 47.30-24.51L47.30-24.51L47.30-24.51Q50.47-24.51 52.80-23.14L52.80-23.14L52.80-23.14Q55.13-21.78 56.28-19.71L56.28-19.71L56.28-24.11L60.32-24.11L60.32 0L56.28 0L56.28-4.49L56.28-4.49Q55.09-2.38 52.73-0.99L52.73-0.99L52.73-0.99Q50.38 0.40 47.26 0.40L47.26 0.40L47.26 0.40Q44.04 0.40 41.45-1.19L41.45-1.19L41.45-1.19Q38.85-2.77 37.36-5.63L37.36-5.63L37.36-5.63Q35.86-8.49 35.86-12.14L35.86-12.14zM56.28-12.10L56.28-12.10Q56.28-14.83 55.18-16.85L55.18-16.85L55.18-16.85Q54.08-18.88 52.21-19.95L52.21-19.95L52.21-19.95Q50.34-21.03 48.09-21.03L48.09-21.03L48.09-21.03Q45.85-21.03 44-19.98L44-19.98L44-19.98Q42.15-18.92 41.05-16.90L41.05-16.90L41.05-16.90Q39.95-14.87 39.95-12.14L39.95-12.14L39.95-12.14Q39.95-9.37 41.05-7.33L41.05-7.33L41.05-7.33Q42.15-5.28 44-4.20L44-4.20L44-4.20Q45.85-3.12 48.09-3.12L48.09-3.12L48.09-3.12Q50.34-3.12 52.21-4.20L52.21-4.20L52.21-4.20Q54.08-5.28 55.18-7.33L55.18-7.33L55.18-7.33Q56.28-9.37 56.28-12.10L56.28-12.10",
    fill: "#5e6fa3",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-124.78497314453125,12.874397638494322)",
    style: {
      fill: "rgb(94, 111, 163)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "-51.79px 0.599398px",
      animation: "1s linear -0.48s infinite normal forwards running fade-926a1358-fcdf-495b-96e6-661e57c75436"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.10-19.54L71.10-19.54Q72.16-21.91 74.12-23.23L74.12-23.23L74.12-23.23Q76.08-24.55 78.89-24.55L78.89-24.55L78.89-20.42L77.84-20.42L77.84-20.42Q71.10-20.42 71.10-13.11L71.10-13.11L71.10 0L67.10 0L67.10-24.11L71.10-24.11L71.10-19.54",
    fill: "#5e6fa3",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-124.78497314453125,12.874397638494322)",
    style: {
      fill: "rgb(94, 111, 163)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "-30.535px 6.5594px",
      animation: "1s linear -0.42s infinite normal forwards running fade-926a1358-fcdf-495b-96e6-661e57c75436"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.46-24.51L93.46-24.51Q96.58-24.51 98.93-23.14L98.93-23.14L98.93-23.14Q101.29-21.78 102.43-19.71L102.43-19.71L102.43-24.11L106.48-24.11L106.48 0.53L106.48 0.53Q106.48 3.83 105.07 6.40L105.07 6.40L105.07 6.40Q103.66 8.98 101.05 10.43L101.05 10.43L101.05 10.43Q98.43 11.88 94.95 11.88L94.95 11.88L94.95 11.88Q90.20 11.88 87.03 9.64L87.03 9.64L87.03 9.64Q83.86 7.39 83.29 3.52L83.29 3.52L87.25 3.52L87.25 3.52Q87.91 5.72 89.98 7.06L89.98 7.06L89.98 7.06Q92.05 8.40 94.95 8.40L94.95 8.40L94.95 8.40Q98.25 8.40 100.34 6.34L100.34 6.34L100.34 6.34Q102.43 4.27 102.43 0.53L102.43 0.53L102.43-4.53L102.43-4.53Q101.24-2.42 98.91-1.01L98.91-1.01L98.91-1.01Q96.58 0.40 93.46 0.40L93.46 0.40L93.46 0.40Q90.24 0.40 87.63-1.19L87.63-1.19L87.63-1.19Q85.01-2.77 83.51-5.63L83.51-5.63L83.51-5.63Q82.02-8.49 82.02-12.14L82.02-12.14L82.02-12.14Q82.02-15.84 83.51-18.63L83.51-18.63L83.51-18.63Q85.01-21.43 87.63-22.97L87.63-22.97L87.63-22.97Q90.24-24.51 93.46-24.51L93.46-24.51zM102.43-12.10L102.43-12.10Q102.43-14.83 101.33-16.85L101.33-16.85L101.33-16.85Q100.23-18.88 98.36-19.95L98.36-19.95L98.36-19.95Q96.49-21.03 94.25-21.03L94.25-21.03L94.25-21.03Q92.00-21.03 90.16-19.98L90.16-19.98L90.16-19.98Q88.31-18.92 87.21-16.90L87.21-16.90L87.21-16.90Q86.11-14.87 86.11-12.14L86.11-12.14L86.11-12.14Q86.11-9.37 87.21-7.33L87.21-7.33L87.21-7.33Q88.31-5.28 90.16-4.20L90.16-4.20L90.16-4.20Q92.00-3.12 94.25-3.12L94.25-3.12L94.25-3.12Q96.49-3.12 98.36-4.20L98.36-4.20L98.36-4.20Q100.23-5.28 101.33-7.33L101.33-7.33L101.33-7.33Q102.43-9.37 102.43-12.10L102.43-12.10",
    fill: "#5e6fa3",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-124.78497314453125,12.874397638494322)",
    style: {
      fill: "rgb(94, 111, 163)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "-0.794971px 0.819397px",
      animation: "1s linear -0.36s infinite normal forwards running fade-926a1358-fcdf-495b-96e6-661e57c75436"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.76-12.14L111.76-12.14Q111.76-15.84 113.26-18.63L113.26-18.63L113.26-18.63Q114.75-21.43 117.37-22.97L117.37-22.97L117.37-22.97Q119.99-24.51 123.20-24.51L123.20-24.51L123.20-24.51Q126.37-24.51 128.70-23.14L128.70-23.14L128.70-23.14Q131.03-21.78 132.18-19.71L132.18-19.71L132.18-24.11L136.22-24.11L136.22 0L132.18 0L132.18-4.49L132.18-4.49Q130.99-2.38 128.63-0.99L128.63-0.99L128.63-0.99Q126.28 0.40 123.16 0.40L123.16 0.40L123.16 0.40Q119.94 0.40 117.35-1.19L117.35-1.19L117.35-1.19Q114.75-2.77 113.26-5.63L113.26-5.63L113.26-5.63Q111.76-8.49 111.76-12.14L111.76-12.14zM132.18-12.10L132.18-12.10Q132.18-14.83 131.08-16.85L131.08-16.85L131.08-16.85Q129.98-18.88 128.11-19.95L128.11-19.95L128.11-19.95Q126.24-21.03 123.99-21.03L123.99-21.03L123.99-21.03Q121.75-21.03 119.90-19.98L119.90-19.98L119.90-19.98Q118.05-18.92 116.95-16.90L116.95-16.90L116.95-16.90Q115.85-14.87 115.85-12.14L115.85-12.14L115.85-12.14Q115.85-9.37 116.95-7.33L116.95-7.33L116.95-7.33Q118.05-5.28 119.90-4.20L119.90-4.20L119.90-4.20Q121.75-3.12 123.99-3.12L123.99-3.12L123.99-3.12Q126.24-3.12 128.11-4.20L128.11-4.20L128.11-4.20Q129.98-5.28 131.08-7.33L131.08-7.33L131.08-7.33Q132.18-9.37 132.18-12.10L132.18-12.10",
    fill: "#5e6fa3",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-124.78497314453125,12.874397638494322)",
    style: {
      fill: "rgb(94, 111, 163)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "29.015px 0.599398px",
      animation: "1s linear -0.3s infinite normal forwards running fade-926a1358-fcdf-495b-96e6-661e57c75436"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.75-24.55L154.75-24.55Q159.15-24.55 161.88-21.89L161.88-21.89L161.88-21.89Q164.60-19.23 164.60-14.21L164.60-14.21L164.60 0L160.64 0L160.64-13.64L160.64-13.64Q160.64-17.25 158.84-19.16L158.84-19.16L158.84-19.16Q157.04-21.08 153.91-21.08L153.91-21.08L153.91-21.08Q150.74-21.08 148.87-19.10L148.87-19.10L148.87-19.10Q147.00-17.12 147.00-13.33L147.00-13.33L147.00 0L143 0L143-24.11L147.00-24.11L147.00-20.68L147.00-20.68Q148.19-22.53 150.24-23.54L150.24-23.54L150.24-23.54Q152.28-24.55 154.75-24.55L154.75-24.55",
    fill: "#5e6fa3",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-124.78497314453125,12.874397638494322)",
    style: {
      fill: "rgb(94, 111, 163)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "57.11px -3.2056px",
      animation: "1s linear -0.24s infinite normal forwards running fade-926a1358-fcdf-495b-96e6-661e57c75436"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.66-12.14L169.66-12.14Q169.66-15.84 171.16-18.63L171.16-18.63L171.16-18.63Q172.66-21.43 175.27-22.97L175.27-22.97L175.27-22.97Q177.89-24.51 181.15-24.51L181.15-24.51L181.15-24.51Q183.96-24.51 186.38-23.21L186.38-23.21L186.38-23.21Q188.80-21.91 190.08-19.80L190.08-19.80L190.08-32.56L194.13-32.56L194.13 0L190.08 0L190.08-4.53L190.08-4.53Q188.89-2.38 186.56-0.99L186.56-0.99L186.56-0.99Q184.23 0.40 181.10 0.40L181.10 0.40L181.10 0.40Q177.89 0.40 175.27-1.19L175.27-1.19L175.27-1.19Q172.66-2.77 171.16-5.63L171.16-5.63L171.16-5.63Q169.66-8.49 169.66-12.14L169.66-12.14zM190.08-12.10L190.08-12.10Q190.08-14.83 188.98-16.85L188.98-16.85L188.98-16.85Q187.88-18.88 186.01-19.95L186.01-19.95L186.01-19.95Q184.14-21.03 181.90-21.03L181.90-21.03L181.90-21.03Q179.65-21.03 177.80-19.98L177.80-19.98L177.80-19.98Q175.96-18.92 174.86-16.90L174.86-16.90L174.86-16.90Q173.76-14.87 173.76-12.14L173.76-12.14L173.76-12.14Q173.76-9.37 174.86-7.33L174.86-7.33L174.86-7.33Q175.96-5.28 177.80-4.20L177.80-4.20L177.80-4.20Q179.65-3.12 181.90-3.12L181.90-3.12L181.90-3.12Q184.14-3.12 186.01-4.20L186.01-4.20L186.01-4.20Q187.88-5.28 188.98-7.33L188.98-7.33L188.98-7.33Q190.08-9.37 190.08-12.10L190.08-12.10",
    fill: "#5e6fa3",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-124.78497314453125,12.874397638494322)",
    style: {
      fill: "rgb(94, 111, 163)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "86.81px 0.819397px",
      animation: "1s linear -0.18s infinite normal forwards running fade-926a1358-fcdf-495b-96e6-661e57c75436"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.42 0.40L211.42 0.40Q208.03 0.40 205.28-1.14L205.28-1.14L205.28-1.14Q202.53-2.68 200.97-5.52L200.97-5.52L200.97-5.52Q199.41-8.36 199.41-12.10L199.41-12.10L199.41-12.10Q199.41-15.80 201.01-18.63L201.01-18.63L201.01-18.63Q202.62-21.47 205.39-22.99L205.39-22.99L205.39-22.99Q208.16-24.51 211.60-24.51L211.60-24.51L211.60-24.51Q215.03-24.51 217.80-22.99L217.80-22.99L217.80-22.99Q220.57-21.47 222.18-18.66L222.18-18.66L222.18-18.66Q223.78-15.84 223.78-12.10L223.78-12.10L223.78-12.10Q223.78-8.36 222.13-5.52L222.13-5.52L222.13-5.52Q220.48-2.68 217.67-1.14L217.67-1.14L217.67-1.14Q214.85 0.40 211.42 0.40L211.42 0.40zM211.42-2.99L211.42-2.99Q213.58-2.99 215.47-4.03L215.47-4.03L215.47-4.03Q217.36-5.06 218.53-7.13L218.53-7.13L218.53-7.13Q219.69-9.20 219.69-12.10L219.69-12.10L219.69-12.10Q219.69-15.00 218.55-17.05L218.55-17.05L218.55-17.05Q217.40-19.10 215.56-20.11L215.56-20.11L215.56-20.11Q213.71-21.12 211.55-21.12L211.55-21.12L211.55-21.12Q209.35-21.12 207.53-20.11L207.53-20.11L207.53-20.11Q205.70-19.10 204.60-17.05L204.60-17.05L204.60-17.05Q203.50-15.00 203.50-12.10L203.50-12.10L203.50-12.10Q203.50-9.15 204.58-7.11L204.58-7.11L204.58-7.11Q205.66-5.06 207.46-4.03L207.46-4.03L207.46-4.03Q209.26-2.99 211.42-2.99L211.42-2.99",
    fill: "#5e6fa3",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-124.78497314453125,12.874397638494322)",
    style: {
      fill: "rgb(94, 111, 163)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "105.51px 10.4094px",
      animation: "1s linear -0.12s infinite normal forwards running fade-926a1358-fcdf-495b-96e6-661e57c75436"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.34 0.26L230.34 0.26Q229.20 0.26 228.40-0.53L228.40-0.53L228.40-0.53Q227.61-1.32 227.61-2.46L227.61-2.46L227.61-2.46Q227.61-3.61 228.40-4.40L228.40-4.40L228.40-4.40Q229.20-5.19 230.34-5.19L230.34-5.19L230.34-5.19Q231.44-5.19 232.21-4.40L232.21-4.40L232.21-4.40Q232.98-3.61 232.98-2.46L232.98-2.46L232.98-2.46Q232.98-1.32 232.21-0.53L232.21-0.53L232.21-0.53Q231.44 0.26 230.34 0.26L230.34 0.26",
    fill: "#5e6fa3",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-124.78497314453125,12.874397638494322)",
    style: {
      fill: "rgb(94, 111, 163)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "114.75px 10.4094px",
      animation: "1s linear -0.06s infinite normal forwards running fade-926a1358-fcdf-495b-96e6-661e57c75436"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.58 0.26L239.58 0.26Q238.44 0.26 237.64-0.53L237.64-0.53L237.64-0.53Q236.85-1.32 236.85-2.46L236.85-2.46L236.85-2.46Q236.85-3.61 237.64-4.40L237.64-4.40L237.64-4.40Q238.44-5.19 239.58-5.19L239.58-5.19L239.58-5.19Q240.68-5.19 241.45-4.40L241.45-4.40L241.45-4.40Q242.22-3.61 242.22-2.46L242.22-2.46L242.22-2.46Q242.22-1.32 241.45-0.53L241.45-0.53L241.45-0.53Q240.68 0.26 239.58 0.26L239.58 0.26",
    fill: "#5e6fa3",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-124.78497314453125,12.874397638494322)",
    style: {
      fill: "rgb(94, 111, 163)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "123.99px 10.4094px",
      animation: "1s linear 0s infinite normal forwards running fade-926a1358-fcdf-495b-96e6-661e57c75436"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.82 0.26L248.82 0.26Q247.68 0.26 246.88-0.53L246.88-0.53L246.88-0.53Q246.09-1.32 246.09-2.46L246.09-2.46L246.09-2.46Q246.09-3.61 246.88-4.40L246.88-4.40L246.88-4.40Q247.68-5.19 248.82-5.19L248.82-5.19L248.82-5.19Q249.92-5.19 250.69-4.40L250.69-4.40L250.69-4.40Q251.46-3.61 251.46-2.46L251.46-2.46L251.46-2.46Q251.46-1.32 250.69-0.53L250.69-0.53L250.69-0.53Q249.92 0.26 248.82 0.26L248.82 0.26",
    fill: "#5e6fa3",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-124.78497314453125,12.874397638494322)",
    style: {
      fill: "rgb(94, 111, 163)"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargando);
export default __webpack_public_path__ + "static/media/cargando.811588335c5418244ad2d2a02051b727.svg";
export { ForwardRef as ReactComponent };